import React from 'react';
import cloudErrorIcon from "../../../assets/claraViewMedia/cloud-error.png";

const ServerError = ({ setCamera, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center font-novatica">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md mx-4">
                <div className="flex justify-end">
                    <button onClick={onClose} className="text-black hover:text-gray-700">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </button>
                </div>
                <div className="text-center">
                    <img src={cloudErrorIcon} alt="Server Error" className="mx-auto h-32" />
                    <h2 className="text-2xl font-medium mt-4 text-[17px] text-[#2C2D24]">ERROR</h2>
                    <p className="text-[15px] text-claraview-tertiary mt-2">AI is currently down and please proceed the scan later.</p>
                </div>
                <div className="mt-8 flex flex-col items-center gap-4">
                    <button onClick={setCamera} className="bg-[#2C2D24] text-[17px] font-medium text-white px-4 h-12 rounded-lg w-48 ">Retake Scan</button>
                </div>
            </div>
        </div>
    );
};

export default ServerError;
